module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-Regular.dc5f0a7.woff";